import { z } from 'zod';
import { CountrySchema } from './Country';

export const DepositTakingBankDetailsSchema = z.object({
  id: z.string(),
  name: z.string(),
  bank_slug: z.string(),
  description: z.string(),
  bank_logo_url: z.string().url(),
  logo_url: z.string().url().nullish(),
  branch_country: CountrySchema,
  address: z.object({
    street: z.string(),
    city: z.string(),
    region: z.string().optional(),
    postal_code: z.string(),
    country: z.string(),
  }),
  statutory_deposit_guarantee_scheme: z.object({
    name: z.string().optional(),
    insured_amount: z.string().optional(),
    logo_url: z.string().optional(),
    country: CountrySchema.nullish(),
    description: z.string(),
    currency: z.string(),
  }),
  voluntary_deposit_guarantee_scheme: z.object({
    name: z.string().nullable(),
    description: z.string().nullable(),
    insured_amount: z.string().nullable(),
    currency: z.string().nullable(),
    logo_url: z.string().nullable(),
  }),
  customer_deposit_limit: z.array(z.string()),
  shariah_compliant: z.boolean(),
});

export type DepositTakingBankDetails = z.infer<typeof DepositTakingBankDetailsSchema>;
